import React from 'react'

const HistoryContext = React.createContext({})
HistoryContext.displayName = 'HistoryContext'

export default HistoryContext
